import React from 'react';
import { useLocation } from 'react-router-dom';
import { linkTabs } from '../../tabHref';
import {
    CONFIGURATIONS_TABS,
    resolveConfigurationsTabId,
} from './configurationsTabsMeta';

/**
 * Configurations shell state: which tab the URL selects, and nothing else.
 *
 * Deliberately thinner than `useBooksPage`. Books owns a date range because all
 * four of its tabs report over a window; a fiscal calendar and a set of tax
 * rates are not read over one, so there is nothing for this shell to hold. The
 * date fields on the Settings tab are inputs to a rate change ("effective
 * from") and an as-of lookup — they belong to those operations, not to the
 * shell.
 */
export const useConfigurationsPage = () => {
    const { pathname } = useLocation();

    const selectedTabId = resolveConfigurationsTabId(pathname);

    const tabs = React.useMemo(() => linkTabs(CONFIGURATIONS_TABS), []);

    return {
        tabs,
        selectedTabId,
    };
};
